module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.email-notification')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.emailForm,
      "fields": _vm.emailFields
    },
    on: {
      "change": function (data) { return _vm.emailForm = data; },
      "submit": _vm.submitEmailNotification
    }
  }, [(_vm.emailForm.hasEmail) ? _c('data-table', {
    attrs: {
      "model": "event-types",
      "columns": ['name'],
      "isSelected": _vm.isEventTypeSelectedForEmail
    },
    on: {
      "selection-change": _vm.onSelectForEmail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.mobile.push_device_id) ? _c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.push-notification')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.pushForm,
      "fields": _vm.pushFields
    },
    on: {
      "change": function (data) { return _vm.pushForm = data; },
      "submit": _vm.submitPushNotification
    }
  }, [(_vm.pushForm.wantsPushNotifications) ? _c('data-table', {
    attrs: {
      "model": "event-types",
      "columns": ['name'],
      "isSelected": _vm.isEventTypeSelectedForPush
    },
    on: {
      "selection-change": _vm.onSelectForPush
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f7d7592!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification-setting/NotificationSettings.vue
// module id = 1134
// module chunks = 2